import { walletQueryKeys } from "@verde/entities";
import { CircleStackIcon } from "@verde/icons";
import { Alert, Button } from "@verde/ui-core";
import { queryClient } from "@verde/utils";
import React, { useCallback } from "react";
import { useCreditDialog } from "./credit-dialog";

function CreditBarDialogSuccess() {
  const { onClose } = useCreditDialog();

  const handleClose = useCallback(async () => {
    await queryClient.invalidateQueries(walletQueryKeys.balance());
    onClose?.();
  }, [onClose]);

  return (
    <div className="grid gap-4">
      <p className="text-lg font-semibold text-neutral-dark-2">
        Crédito adicionado com sucesso!
      </p>

      <Alert
        kind="success"
        icon={<CircleStackIcon />}
        classNames={{
          base: "border",
        }}
      >
        Seus créditos já estão disponíveis para realizar consultas.
      </Alert>

      <hr />

      <div className="grid gap-2">
        <Button kind="secondary" size="lg" onClick={handleClose}>
          Fechar
        </Button>
      </div>
    </div>
  );
}

export default React.memo(CreditBarDialogSuccess);
